(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-big-band"]) return;
  try {
    
      
 
 
 

var table = $('#productList').DataTable({
                   pageLength: 250,    
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
    columns: [ 
        {  
            title: 'Song Name',
			width: '20%'
        },
{   
            title: 'Artist',
        },
{  
            title: 'Genre',
        }, 
{  
            title: 'Tempo',
			width: '25px'
        },
{  
            title: 'Diff',
			width: '25px'
        },
 {
            title: 'Vendor'
        },
  
        {
            title: 'Price', 
			width: '40px'
        }
    ]   
});   


var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=250'; 
var url2 = pathname+'?view=json'; 
console.log(url);
var countUrl = pathname+'.json'; 


$.getJSON(countUrl, function () { 
//console.log('Count Success');
}) 
.done(function (data) { 
//console.log(data);  
var feedCount = data.collection.products_count;
 console.log(feedCount, 'json feedCount');   
var pages = (feedCount / 50.0);  
pages = Math.ceil(pages);  
 console.log(pages,'pages'); 
getProducts(pages);
});  







function getProducts(pages) { 
    var productUrls = [url2+'&page='+pages];
 
    while(pages != 1) { 
        pages -= 1;    
        productUrls.push(url2+'&page='+pages); 
    }
    
    console.log(productUrls);
    $.each(productUrls, function(i,u){ 
        $.ajax(u, 
          { type: 'GET',
            success: function (data) {
                   json_data = JSON.parse(data);
                   // Call this function on success
                   //console.log( 'data is ', json_data );
               
               var products = json_data.products;
               $(products).each(function () {   
                   var songName = this.title;  
                      //console.log(songName);   
                   var price = this.price; 
                    //console.log(price);
                   var songUrl = this.url 
                    //console.log(songUrl);
 				   var album = this.album; 
				    var genre = this.genre;
					if(genre != null ){
						genre = '<a href="/pages/'+this.genreHandle+'">'+this.genre+'</a>'
					}
    				var drummer = this.drummer;
					if(drummer != null ){
						drummer = '<a href="/pages/'+this.drummerHandle+'">'+this.drummer+'</a>'
					}

	var artist = this.artist;
					if(artist != null ){
						artist = '<a href="/pages/'+this.artistHandle+'">'+this.artist+'</a>'
					}

                   
                 
                table.row.add(
               [     
				   '<a href="/products/'+songUrl+'">'+this.title+'</a>',
				artist,
                   genre,
                  this.tempo, 
				this.difficulty,
				 this.vendor,
                  this.price  
               ] 
               );   
              
               });
 table.draw();   
            },
       error: function() {
       console.log('Error occured checking limit');
   } 
          }
        ); 

   });  
  
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-data-table-test"]) return;
  try {
    
      
 
 
 

var table = $('#productList').DataTable({
           pageLength: 250,    
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
    columns: [ 
        {  
            title: 'Song Name',
			width: '20%'
        },
{  
            title: 'Artist',
        },
{   
            title: 'Genre',
        },
{  
            title: 'Drummer',
        },
{  
            title: 'Diff',
			width: '25px'
        },
 {
            title: 'Type'
        },
 {
            title: 'Vendor'
        },
  
        {
            title: 'Price', 
			width: '40px'
        }
    ]   
});   


var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=250'; 
var url2 = pathname+'?view=json'; 
console.log(url);
var countUrl = pathname+'.json'; 


$.getJSON(countUrl, function () { 
//console.log('Count Success');
}) 
.done(function (data) { 
//console.log(data);  
var feedCount = data.collection.products_count;
 console.log(feedCount, 'json feedCount');   
var pages = (feedCount / 50.0);  
pages = Math.ceil(pages);  
 console.log(pages,'pages'); 
getProducts(pages);
});  







function getProducts(pages) { 
    var productUrls = [url2+'&page='+pages];
 
    while(pages != 1) { 
        pages -= 1;    
        productUrls.push(url2+'&page='+pages); 
    }
    
    console.log(productUrls);
    $.each(productUrls, function(i,u){ 
        $.ajax(u, 
          { type: 'GET',
            success: function (data) {
                   json_data = JSON.parse(data);
                   // Call this function on success
                   //console.log( 'data is ', json_data );
               
               var products = json_data.products;
               $(products).each(function () {   
                   var songName = this.title;  
                      //console.log(songName);   
                   var price = this.price; 
                    //console.log(price);
                   var songUrl = this.url 
                    //console.log(songUrl);
 				   var album = this.album; 
				    var genre = this.genre;
					if(genre != null ){
						genre = '<a href="/pages/'+this.genreHandle+'">'+this.genre+'</a>'
					}
    				var drummer = this.drummer;
					if(drummer != null ){
						drummer = '<a href="/pages/'+this.drummerHandle+'">'+this.drummer+'</a>'
					}

	var artist = this.artist;
					if(artist != null ){
						artist = '<a href="/pages/'+this.artistHandle+'">'+this.artist+'</a>'
					}

                   
                 
                table.row.add(
               [     
				   '<a href="/products/'+songUrl+'">'+this.title+'</a>',
				artist,
                   genre,
                  drummer, 
				this.difficulty,
				this.type,
				 this.vendor,
                  this.price
               ] 
               );   
              
               });
 table.draw();   
            },
       error: function() {
       console.log('Error occured checking limit');
   } 
          }
        ); 

   });  
  
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-data-table-publications"]) return;
  try {
    
      
 var table = $('#productList').DataTable({
        pageLength: 250,    
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
		dom: 'Alfrtip', 
 		alphabetSearch: { 
         column: 0 
       },
            columns: [ 
 {   image: '' },
               // {   title: 'Title' },
 			//	{    title: 'Album'  },
 				//{   title: 'Genre' },
 				//{    title: 'Drummer'  },
 				//{    title: 'Date'  },
 			//	{   title: 'Tempo' },
               // {  title: 'price' }
            ],
createdRow: function (row, data, dataIndex) {
    $(row).addClass('grid__item');
}
        });   

var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=250'; 
var url2 = pathname+'?view=publication.json'; 
console.log(url2);
var countUrl = pathname+'.json'; 
 

$.getJSON(countUrl, function () {
        console.log('Count Success');
    }) 
    .done(function (data) {   
		 console.log(data);  
		var feedCount = data.collection.products_count;
		//console.log(feedCount, 'json feedCount');   
		var pages = (feedCount / 50.0);  
		pages = Math.ceil(pages);  
		//console.log(pages,'pages'); 
 		getProducts(pages);
 	 });  
  
   

function getProducts(pages) { 
 $.ajax({
        type: "GET",
        url: url2+'&page='+pages,
        success: function(data) {
            json_data = JSON.parse(data);
            // Call this function on success
             console.log( 'data is ', json_data ); 

 var products = json_data.products 

if(products && pages > 0) { 
			
		pages -= 1; 
		console.log('new pages', pages); 
        	$(products).each(function () {
			//console.log(this);
			var songName = this.title;  
			   //console.log(songName);  
          	var price = this.price; 
			 //console.log(price);
			var songUrl = this.url
			 //console.log(songUrl); 
           
     
 		table.row.add(
		[       
'<a href="/products/'+this.url+'"><div class="product-image publication-image"><img  class="lazyload"  alt=""  data-src="'+this.image+'"   data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="auto" data-sizes="auto"></div><h3 class="h4 product-title">'+this.title+'</h3><div class="product-price">'+this.price+'</div></a>', 
      		//this.title, 
			//this.album,
			//this.genre,
			//this.drummer, 
			//this.date,
			//this.tempo,
		   	//this.price
    	] 
		);  
        table.draw();   
        });
  	
		getProducts(pages); 
	} else {  
		table.draw();
	} 
        },
        error: function() {
            console.log('Error occured checking limit');
        }
    });
 
 }
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-data-table-recent"]) return;
  try {
    
      
 
 
 

var table = $('#productList').DataTable({
      			pageLength: 50, 
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },   
    columns: [ 
        {  
            title: 'Song Name',
			width: '20%'
        },
{  
            title: 'Artist',
        },
{  
            title: 'Genre',
        },
{  
            title: 'Drummer',
        },
{  
            title: 'Diff',
			width: '40px'
        },
 {
            title: 'Type'
        },
 {
            title: 'Vendor'
        },
  
        {
            title: 'Price', 
			width: '40px'
        }
    ]   
});   


var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=50'; 
var url2 = pathname+'?view=recent-json'; 
console.log(url2); 
var countUrl = pathname+'.json'; 


$.getJSON(countUrl, function () { 
//console.log('Count Success');
}) 
.done(function (data) { 
//console.log(data);  
var feedCount = data.collection.products_count;
 console.log(feedCount, 'json feedCount');   
var pages = (feedCount / 50.0);  
pages = Math.ceil(pages);  
 console.log(pages,'pages'); 
getProducts(pages);
});  




 


function getProducts(pages) { 
    var productUrls = [url2+'&page='+pages];
 
    while(pages != 1) { 
        pages -= 1;    
        productUrls.push(url2+'&page='+pages); 
    }
    
    console.log(productUrls);
    $.each(productUrls, function(i,u){ 
        $.ajax(u, 
          { type: 'GET',
            success: function (data) {
					//console.log(u);
                   json_data = JSON.parse(data);
                   // Call this function on success
                   //console.log( 'data is ', json_data );
               
               var products = json_data.products;
               $(products).each(function () { 
					if(this.title != null) {
                   var songName = this.title;  
                      //console.log(songName);   
                   var price = this.price; 
                    //console.log(price);
                   var songUrl = this.url 
                    //console.log(songUrl);
 				   var album = this.album; 
				    var genre = this.genre;
					if(genre != null ){
						genre = '<a href="/pages/'+this.genreHandle+'">'+this.genre+'</a>'
					}
    				var drummer = this.drummer;
					if(drummer != null ){
						drummer = '<a href="/pages/'+this.drummerHandle+'">'+this.drummer+'</a>'
					}

					var artist = this.artist;
					if(artist != null ){
						artist = '<a href="/pages/'+this.artistHandle+'">'+this.artist+'</a>'
					}

                   
                 
                table.row.add(
               [     
				   '<a href="/products/'+songUrl+'">'+this.title+'</a>',
				artist,
                   genre,
                  drummer, 
				this.difficulty,
				this.type,
				 this.vendor,
                  this.price
               ] 
               );   
              }
               });
 table.draw();   
            },
       error: function() {
       console.log('Error occured checking limit');
   } 
          }
        ); 

   });  
  
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-data-table"]) return;
  try {
    
      
 var table = $('#productList').DataTable({
        pageLength: 250,    
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
		dom: 'Alfrtip', 
 		alphabetSearch: { 
         column: 0
       }, 
            columns: [ 
                {  
                    title: 'Song Name',
                },
 {  
                    title: 'Album',
                },
 {  
                    title: 'Genre',
                },
 {  
                    title: 'Drummer',
                },
 {  
                    title: 'Date',
                },
 {  
                    title: 'Tempo',
                },
                {
                    title: 'price'
                }
            ]

        });   


var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=250'; 
var url2 = pathname+'?view=json'; 
console.log(url);
var countUrl = pathname+'.json'; 
 

$.getJSON(countUrl, function () {
        console.log('Count Success');
    }) 
    .done(function (data) {   
		//console.log(data);  
		var feedCount = data.collection.products_count;
		//console.log(feedCount, 'json feedCount');   
		var pages = (feedCount / 50.0);  
		pages = Math.ceil(pages);  
		//console.log(pages,'pages'); 






 getProducts(pages);

  

	 });  
  
   

function getProducts(pages) { 
 $.ajax({
        type: "GET",
        url: url2+'&page='+pages,
        success: function(data) {
            json_data = JSON.parse(data);
            // Call this function on success
            //console.log( 'data is ', json_data );

 var products = json_data.products

if(products && pages > 0) { 
			
		pages -= 1; 
		console.log('new pages', pages); 
        	$(products).each(function () {   
			var songName = this.title;  
			   //console.log(songName);  
          	var price = this.price; 
			 //console.log(price);
			var songUrl = this.url
			 //console.log(songUrl); 
           
     
 		table.row.add(    
		[   
      		this.title, 
			this.album,
			this.genre,
			this.drummer, 
			this.date,
			this.tempo,
		   	this.price
    	] 
		);  
        table.draw();   
        });
  	
		getProducts(pages); 
	} else {  
		table.draw();
	} 
        },
        error: function() {
            console.log('Error occured checking limit');
        }
    });
 
 }

/*
function getProducts(pages) {  

var feed = $.getJSON(url+'&page='+pages, function () {  
        console.log(feed);
    })  
    .done(function (data) {   
  		console.log(data); 
		if(data.products && pages > 0) { 
			
		pages -= 1; 
		console.log('new pages', pages);
        //console.log('second success');
        var entry = data.products;
        console.log(data);  
        $(entry).each(function () {   
			var songName = this.title;  
			//  console.log(songName);  
          	var price = this.variants[0].price; 
			//console.log(price);
			var songUrl = this.handle
			//console.log(songUrl); 
           
     
 		table.row.add(    
		[   
      		songName, 
		   price
    	] 
		);   
           
        });
  	
		getProducts(pages); 
	} else {  
		table.draw();
	}
    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });


} */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-top10"]) return;
  try {
    
      
 
 

var table = $('#productList').DataTable({
        
    columns: [ 
        {  
            title: 'Song Name',
			width : '20%'
        },
{  
            title: 'Artist',
        },
{  
            title: 'Genre',
        },
{  
            title: 'Drummer',
        },
{  
            title: 'Diff',
        },
 {
            title: 'Type'
        },
 {
            title: 'Vendor'
        },
  
        {
            title: 'Price', 
			width : '40px'
        }
    ]   
});   


var pathname = window.location.pathname;
var url = pathname+'/products.json?limit=10'; 
var url2 = pathname+'?view=json'; 


$.ajax(url2,{  
      type: 'GET',
      success: function (data) {
        
  json_data = JSON.parse(data);
                   // Call this function on success
                   //console.log( 'data is ', json_data );
               
               var products = json_data.products;
$.each(products.slice(0,10),function () {  
           
             var songName = this.title;  
                //console.log(songName);   
             var price = this.price; 
              //console.log(price);
             var songUrl = this.url 
              //console.log(songUrl);
              var album = this.album; 
              var genre = this.genre;
              if(genre != null ){
                  genre = '<a href="/pages/'+this.genreHandle+'">'+this.genre+'</a>'
              }
              var drummer = this.drummer;
              if(drummer != null ){
                  drummer = '<a href="/pages/'+this.drummerHandle+'">'+this.drummer+'</a>'
              }

             var artist = this.artist;
              if(artist != null ){
                  artist = '<a href="/pages/'+this.artistHandle+'">'+this.artist+'</a>'
              }

             
           
          table.row.add(
         [     
             '<a href="/products/'+songUrl+'">'+this.title+'</a>',
          artist,
             genre,
            drummer, 
          this.difficulty,
          this.type,
           this.vendor,
            this.price
         ] 
         );   
        
         });
table.draw();   
      },
 error: function() {
 console.log('Error occured checking limit');
} 
    }); 
 



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-all-songs"]) return;
  try {
      
var sheetNumber = $('#artistContainer').data('sheet');

 // ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey; // Sheet Number is now the name of the tab in sheets

 

var results = [];


var feed = $.getJSON(url, function () { 
         console.log(url);
    }) 
.done(function (data) {
        //console.log('second success'); 
        $(data.values).each(function () {
           //  console.log(this[4]);   


            var songTitle = this[1];
            var album = this[3];
            var artist = this[2];
            var genre = this[5];
            var tempo = this[8];
            var difficulty = this[7];
            var year = this[6];
  		    var songName = this[1];
    		
 
			  var drummer = this[4]; 
           if(artist){ 
            var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
           if(drummer){ 
            var drummerHandle = drummer.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
           	if(genre){ 
            var genreHandle = genre.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
           if(songName){ 
            var songHandle = songName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
            var songUrl = "/collections/" + songHandle + "-" + artistHandle;
            var artistUrl = "/pages/" + artistHandle;
            var drummerUrl = "/pages/" + drummerHandle;
            var genreUrl = "/pages/" + genreHandle;
        

results.push([
songTitle, 
artist, 
album, 
drummer, 
genre, 
difficulty, 
year, 
tempo, 
songUrl, 
drummerUrl, 
genreUrl, 
artistUrl
]); 
});



//console.log(results);
        var table = $('#songList').DataTable({ 
        data: results, 
		pageLength: 250, 

language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
		dom: 'Alfrtip', 
 		alphabetSearch: { 
         column: 0
       },
            columns: [ 
                 {  
                    title: 'Song Name',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[8] + '">'+data+'</a>';
                        }
                    
                        return data; 
                }  
            },
 {   
                    title: 'Artist',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[11] + '">'+data+'</a>';
                        }
                    
                        return data; 
}
                }, 
                {
                    title: 'Album' 
                },
                   {  
                    title: 'Drummer', 
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[9] + '">'+data+'</a>';
                        }
                    	 
                        return data; 
						 
}
                },
                   {  
                    title: 'Genre',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[10] + '">'+data+'</a>';
                        }  
                     
                        return data; 
}
                },
                {
                    title: 'Difficulty'
                },
                {
                    title: 'Year' 
                },
                {
                    title: 'Tempo'
                }
            ],
columnDefs: [{
                "defaultContent": "-",
                "targets": "_all"
            }] 
        }); 

    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });


 





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-alphabetical"]) return;
  try {
    
var sheetNumber = $('#artistContainer').data('sheet');
var artistName = $('#artistContainer').data('artist-name');

// ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey;
// Sheet Number is now the name of the tab in sheets
var results = [];
var feed = $.getJSON(url, function () {
console.log('success',url);
})
.done(function (data) {
//console.log('second success');
var entry = data;
console.log(data);
$(entry.values).each(function () {
var artistName = this[0];
var artistHandle = this[1];
console.log(artistHandle);
if(!(artistHandle)) {
if(artistName){
var artistHandle = artistName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/,
'').replace(/^-/, '');
}
} else {
//console.log(artistHandle);
var realArtistHandle = artistHandle;
}
var artistUrl = realArtistHandle ? "/pages/" + realArtistHandle : "/pages/"+artistHandle;


//console.log(artistUrl);
if(artistName){
results.push([artistName, artistUrl]);
}
});
var table = $('#artistList').DataTable({

data: results,
pageLength: 250,
dom: 'Alfrtip',
alphabetSearch: {
column: 0
},
language: {
'lengthMenu': 'Display <select>'+
    '<option value="50">50</option>'+
    '<option value="100">100</option>'+
    '<option value="150">150</option>'+
    '<option value="200">200</option>'+
    '<option value="250">250</option>'+
    '<option value="-1">All</option>'+
    '</select> records'
},
columns: [
{
title: 'Artist Name',
"render": function (data, type, row, meta) {
if (type === 'display') {

data = '<a href="' + row[1] + '">'+data+'</a>';
}

return data;
}
}
],
columnDefs: [{
"defaultContent": "-",
"targets": "_all"
}]


});

})
.fail(function () {
console.log('error');
})
.always(function () {
console.log('complete');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-artist-collection"]) return;
  try {
    

var artistName = $('#artistContainer').data('artist-name');
 // ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://spreadsheets.google.com/feeds/list/" + spreadsheetID + "/od6/public/values?alt=json";



var results = [];


var feed = $.getJSON(url, function () { 
        console.log('success');
    }) 
    .done(function (data) {
        //console.log('second success');
        var entry = data.feed.entry;
        // console.log(entry);  
        $(entry).each(function () {
			var songName = this.gsx$songname.$t; 
			//console.log(songName);
           var songHandle = songName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			var songUrl = "/collections/"+songHandle+artistName; 
			console.log(songUrl);
 
            results.push([this.gsx$songname.$t, this.gsx$album.$t, this.gsx$drummer.$t, this.gsx$genre.$t, this.gsx$difficulty.$t, this.gsx$timeframe.$t, this.gsx$tempo.$t, songUrl]);
        });
        var table = $('#songList').DataTable({
            data: results,
			pageLength: 250, 
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  }, 
            columns: [
                {  
                    title: 'Song Name',
                    "render": function (data, type, row, meta) {
                        if (type === 'display') {
							      
                            data = '<a href="' + row[7] + '">'+data+'</a>';
                        }
                    
                        return data;
                }
            },
                {
                    title: 'Album'
                },
                {
                    title: 'Drummer'
                },
                {
                    title: 'Genre'
                },
                {
                    title: 'Difficulty'
                },
                {
                    title: 'Timeframe'
                },
                {
                    title: 'Tempo'
                }
            ] 
        }); 

    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });


 





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-artist-collection2"]) return;
  try {
     
var sheetNumber = $('#artistContainer').data('sheet');
var artistName = $('#artistContainer').data('artist-name');
 
// ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey; // Sheet Number in the url is the tab in sheets
var results = [];
var feed = $.getJSON(url, function () {
        console.log('success ', url);  
    }) 
    .done(function (data) {
       console.log(data);
        $(data.values).each(function () {
            //console.log(this[1]);   
            var songTitle = this[1];
            var artist = this[2];
            var album = this[3];
            var drummer = this[4];
            var genre = this[5];
            var tempo = this[8];
            var difficulty = this[7];
            var year = this[6];
			var songHandle = this[10];
			var artistHandle = this[11];
            var drummerHandle = this[12];
	
if(!(artistHandle)) {
if(artist){ 
            var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}
} else {
console.log(artistHandle);
	var realArtistHandle = artistHandle;
}
if (!(drummerHandle)) {
if (drummer) {
    var drummerHandle = drummer.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/,''); 
}
} else {
 console.log(drummerHandle);
//var realArtistHandle = artistHandle;
}

            var genre = this[5];
			if(genre){ 
            var genreHandle = genre.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
            var songName = this[1];
			
			
			if(!(songHandle)) {
 			if(songName){ 
            var songHandle = songName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
			} else {
		console.log(songHandle);
var realSongHandle = songHandle;
}

 
            var songUrl = realSongHandle ? "/collections/" + realSongHandle : "/collections/" + songHandle + "-" + artistHandle;
            var artistUrl = "/pages/" + artistHandle;
            var drummerUrl = "/pages/" + drummerHandle;
            var genreUrl = "/pages/" + genreHandle;

            if (artistHandle == artistName) {
                //console.log(this);
                results.push([
                    songTitle,
                    album,
                    drummer,
                    genre,
                    difficulty,
                    year,
                    tempo,
                    songUrl,
                    drummerUrl,
                    genreUrl
                ]);
            }

        });
        //console.log('Results ', results);
        var table = $('#songList').DataTable({
            data: results,
            pageLength: 250,
            language: {
                'lengthMenu': 'Display <select>' +
                    '<option value="50">50</option>' +
                    '<option value="100">100</option>' +
                    '<option value="150">150</option>' +
                    '<option value="200">200</option>' +
                    '<option value="250">250</option>' +
                    '<option value="-1">All</option>' +
                    '</select> records'
            },
            columns: [{
                    title: 'Song Name',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
 if(data){   
                            data = '<a href="' + row[7] + '">' + data + '</a>';
}
                        }
                        return data;
                    }
                },
                {
                    title: 'Album'
                },
                {
                    title: 'Drummer',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
 if(data){   
                            data = '<a href="' + row[8] + '">' + data + '</a>';
}
                        }
                        return data;
                    }
                },
                {
                    title: 'Genre',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
 if(data){   
                            data = '<a href="' + row[9] + '">' + data + '</a>';
}
                        }
                        return data;
                    }
                },
                {
                    title: 'Difficulty'
                },
                {
                    title: 'Year'
                },
                {
                    title: 'Tempo'
                }
            ],
            columnDefs: [{
                "defaultContent": "-",
                "targets": "_all"
            }]
        }); 

    })
    .fail(function (xhr, ajaxOptions, thrownError) {
        console.log('error');
        console.log(xhr.status);
        console.log(xhr.statusText);
        console.log(xhr.responseText);
        $('.collections-list').html(xhr.responseText);
    })
    .always(function () {
        console.log('complete');
    }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-by-drummer"]) return;
  try {
    
var sheetNumber = $('#artistContainer').data('sheet');
var artistName = $('#artistContainer').data('artist-name');

// ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey;
// Sheet Number is now the name of the tab in sheets
var results = [];
var feed = $.getJSON(url, function () {
console.log('success',url);
})
.done(function (data) {
//console.log('second success');
var entry = data;
console.log(data);
$(entry.values).each(function () {
     
var artistName = this[0];
var artistHandle = this[1];



if(!(artistHandle)) {
if(artistName){
var artistHandle = artistName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/,
'').replace(/^-/, '');
}
} else {
console.log(artistHandle);
var realArtistHandle = artistHandle;
}
var artistUrl = realArtistHandle ? "/pages/" + realArtistHandle : "/pages/"+artistHandle;

//console.log(artistUrl);
 if(artistName) {
results.push([artistName, artistUrl]);
 }
});
var table = $('#artistList').DataTable({

data: results,
pageLength: 250,
dom: 'Alfrtip',
alphabetSearch: {
column: 0
},
language: {
'lengthMenu': 'Display <select>'+
    '<option value="50">50</option>'+
    '<option value="100">100</option>'+
    '<option value="150">150</option>'+
    '<option value="200">200</option>'+
    '<option value="250">250</option>'+
    '<option value="-1">All</option>'+
    '</select> records'
},
columns: [
{
title: 'Artist Name',
"render": function (data, type, row, meta) {
if (type === 'display') {
   // console.log(row);
data = '<a href="' + row[1] + '">'+data+'</a>';
}

return data;
}
}
],
columnDefs: [{
"defaultContent": "-",
"targets": "_all"
}]


});

})
.fail(function () {
console.log('error');
})
.always(function () {
console.log('complete');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-by-genre"]) return;
  try {
    
var sheetNumber = $('#artistContainer').data('sheet');
 // ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey; // Sheet Number is now the name of the tab in sheets

 

var results = [];


var feed = $.getJSON(url, function () {  
        console.log('success'); 
    }) 
    .done(function (data) {
        //console.log('second success');  
        $(data.values).each(function () {
						var artist = this[0]; 
			//console.log(songName);
if(artist){ 
            var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}
			var artistUrl = "/pages/"+artistHandle; 
			//console.log(artistUrl);
 
            results.push([artist, artistUrl]);
        });
        var table = $('#artistList').DataTable({
	
            data: results,
			pageLength: 250,  
	dom: 'Alfrtip', 
 		alphabetSearch: { 
         column: 0
      },
language: {
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
            columns: [
                {  
                    title: 'Artist Name',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[1] + '">'+data+'</a>';
                        }
                    
                        return data;
                }
			} 
            ],
columnDefs: [{
                "defaultContent": "-",
                "targets": "_all"
            }]
 
      
        }); 

    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });


 





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-single-drummer"]) return;
  try {
    
var sheetNumber = $('#artistContainer').data('sheet');
var drummerName = $('#artistContainer').data('artist-name');
// ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key=" +
apiKey; // Sheet Number is now the name of the tab in sheets


var results = [];

var feed = $.getJSON(url, function () {
console.log('success ', url);
})
.done(function (data) {
 console.log(data);
$(data.values).each(function () {
var songTitle = this[1];
var album = this[3];
var artist = this[2];
var drummer = this[4];
var genre = this[5];
var tempo = this[8];
var difficulty = this[7];
var year = this[6];
var songHandle = this[32];
var artistHandle = this[33];
var drummerHandle = this[34];

if (!(artistHandle)) {
if (artist) {
var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/,
'');
}
} else {
//console.log(artistHandle);
//var realArtistHandle = artistHandle;
}



if (!(drummerHandle)) {
if (drummer) {
    var drummerHandle = drummer.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/,''); 
}
} else {
 console.log(drummerHandle);
//var realArtistHandle = artistHandle;
}
 
var genre = this[5];
if (genre) {
var genreHandle = genre.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}
var songName = this[1];


if (!(songHandle)) {
if (songName) {
var songHandle = songName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/,
'');
}
} else {
//console.log(songHandle);
var realSongHandle = songHandle;
}

var songUrl = realSongHandle ? "/collections/" + realSongHandle : "/collections/" + songHandle + "-" + artistHandle;
var artistUrl = "/pages/" + artistHandle;
var drummerUrl = "/pages/" + drummerHandle;
var genreUrl = "/pages/" + genreHandle;


if (drummerHandle == drummerName) {
results.push([
songTitle,
artist,
album,
genre,
difficulty,
year,
tempo,
songUrl,
genreUrl,
artistUrl
]);
}
});
//console.log(results);
var table = $('#songList').DataTable({
data: results,
pageLength: 250,
language: {
'lengthMenu': 'Display <select>' +
    '<option value="50">50</option>' +
    '<option value="100">100</option>' +
    '<option value="150">150</option>' +
    '<option value="200">200</option>' +
    '<option value="250">250</option>' +
    '<option value="-1">All</option>' +
    '</select> records'
},
columns: [{
title: 'Song Name',
"render": function (data, type, row, meta) {
if (type === 'display') {

data = '<a href="' + row[7] + '">' + data + '</a>';
}

return data;
}
},
{
title: 'Artist',
"render": function (data, type, row, meta) {
if (type === 'display') {

data = '<a href="' + row[9] + '">' + data + '</a>';
}

return data;
}
},
{
title: 'Album'
},

{
title: 'Genre',
"render": function (data, type, row, meta) {
if (type === 'display') {

data = '<a href="' + row[8] + '">' + data + '</a>';
}

return data;
}
},
{
title: 'Difficulty'
},
{
title: 'Year'
},
{
title: 'Tempo'
}
]
});

//console.log("UNIQUE",table.column(2).data().unique());
table.column(2).data().unique();
})
.fail(function () {
//console.log('error');
})
.always(function () {
//console.log('complete');
});




var drummer,
drummers = [];


$.fn.dataTableExt.afnFiltering.push(
function( oSettings, aData, iDataIndex ) {
 
    console.log(aData,'ADATA');
//return true iDataIndex already is processed
if (drummers[iDataIndex]) return true;
//process drummer, return true and insert into drummers if not already known
drummer = aData[0];
if (drummers.indexOf(drummer)<0) {
    drummers[iDataIndex]=drummer;
    return true;
    } else {
    return false;
    }
    }
    ); 

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-single-genre"]) return;
  try {
     
var sheetNumber = $('#artistContainer').data('sheet');
var genreName = $('#artistContainer').data('genre-name');
 // ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://sheets.googleapis.com/v4/spreadsheets/" + spreadsheetID + "/values/" + sheetNumber + "?key="+ apiKey; // Sheet Number is now the name of the tab in sheets
var results = [];


var feed = $.getJSON(url, function () { 
      //  console.log('success');
    }) 
    .done(function (data) { 
       $(data.values).each(function () {
            //console.log(this[1]);   
            var songTitle = this[1];
            var album = this[3];
            var artist = this[2];
            var genre = this[5];
            var tempo = this[8];
            var difficulty = this[7];
            var year = this[6];
            var drummer = this[4];       
            var genre = this[5];
            var songName = this[1];
         

if(artist){ 
            var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
if(drummer){ 
		 
            var drummerHandle = drummer.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
            var genre = this[5];
			if(genre){ 
            var genreHandle = genre.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
            var songName = this[1];
			if(songName){ 
            var songHandle = songName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			}
            var songUrl = "/collections/" + songHandle + "-" + artistHandle;
            var artistUrl = "/pages/" + artistHandle;
            var drummerUrl = "/pages/" + drummerHandle;
            var genreUrl = "/pages/" + genreHandle;

            if (genreHandle == genreName) {
                //console.log(this);
                results.push([
                    songTitle,
					artist,
                    album,
                    drummer,
                    difficulty,
                    year,
                    tempo,
                    songUrl,
                    drummerUrl
                ]);
            }
        });         
 
//console.log(results);
        var table = $('#songList').DataTable({
            data: results,
			pageLength: 250, 
language: { 
    'lengthMenu': 'Display <select>'+
      '<option value="50">50</option>'+
      '<option value="100">100</option>'+
      '<option value="150">150</option>'+
      '<option value="200">200</option>'+
      '<option value="250">250</option>'+
      '<option value="-1">All</option>'+
      '</select> records'
  },
            columns: [
                {  
                    title: 'Song Name',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[7] + '">'+data+'</a>';
                        }
                    
                        return data; 
                }
            }, 
   {  
                    title: 'Artist',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[8] + '">'+data+'</a>';
                        }
                    
                        return data; 
                }
            },
                {
                    title: 'Album'
                },
                 {   
                    title: 'Drummer',
                    "render": function (data, type, row, meta) {
                        if (type === 'display' && data) {
							      
                            data = '<a href="' + row[9] + '">'+data+'</a>';
                        }
                    
                        return data; 
                }
            },
               
                {
                    title: 'Difficulty' 
                },
                {
                    title: 'Year'
                },
                {
                    title: 'Tempo'
                }
            ],
			columnDefs: [{
                "defaultContent": "-",
                "targets": "_all"
            }]
        }); 

    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });


 





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-top10"]) return;
  try {
     
var sheetNumber = $('#artistContainer').data('sheet');
var genreName = $('#artistContainer').data('genre-name');
// ID of the Google Spreadsheet
var spreadsheetID = $('#artistContainer').data('data');
// Make sure it is public or set to Anyone with link can view 
var url = "https://spreadsheets.google.com/feeds/list/" + spreadsheetID + "/" + sheetNumber + "/public/values?alt=json"; // Sheet Number in the url is the tab in sheets



var results = [];


var feed = $.getJSON(url, function () {
        console.log('success');
    })
    .done(function (data) {
        //console.log('second success');
        var entry = data.feed.entry;
        console.log(entry);
        console.log(entry[0].gsx$topsong.$t);
        $(entry).each(function () {
            //console.log(this.gsx$topsong); 
            var artist = this.gsx$artist.$t;
            var artistHandle = artist.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var drummer = this.gsx$drummer.$t;
            var drummerHandle = drummer.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var genre = this.gsx$genre.$t;
            var genreHandle = genre.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var songName = this.gsx$songtitle.$t;
            //console.log(songName);
            var songHandle = songName.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            var songUrl = "/collections/" + songHandle + "-" + artistHandle;
            //console.log(songUrl);  
            var artistUrl = "/pages/" + artistHandle;
            var drummerUrl = "/pages/" + drummerHandle;


            if (this.gsx$topsong.$t === 'Y') {
                console.log('top-song');
                results.push([this.gsx$songtitle.$t, this.gsx$artist.$t, this.gsx$album.$t, this.gsx$drummer.$t, this.gsx$genre.$t, this.gsx$difficulty.$t, this.gsx$year.$t, this.gsx$tempo.$t, songUrl, artistUrl, drummerUrl]);
            }
        });
        console.log(results);
        var table = $('#songList').DataTable({
            data: results,
            paging: false,
            ordering: false,
            info: false,
            searching: false,
            columns: [{
                    title: 'Song Name',
					className: 'strong-column',
                    "render": function (data, type, row, meta) {
                        if (type === 'display') {

                            data = '<a href="' + row[8] + '">' + data + '</a>';
                        }

                        return data;
                    }
                },
                {
                    title: 'Artist',
                    "render": function (data, type, row, meta) {
                        if (type === 'display') {

                            data = '<a href="' + row[9] + '">' + data + '</a>';
                        }

                        return data;
                    }
                },
                {
                    title: 'Album'
                },
                {
                    title: 'Drummer',
                    "render": function (data, type, row, meta) {
                        if (type === 'display') {

                            data = '<a href="' + row[10] + '">' + data + '</a>';
                        }

                        return data;
                    }
                },
                {
                    title: 'Genre'
                },
                {
                    title: 'Difficulty'
                },
                {
                    title: 'Year'
                },
                {
                    title: 'Tempo'
                }
            ]
        });

    })
    .fail(function () {
        console.log('error');
    })
    .always(function () {
        console.log('complete');
    });

 





  } catch(e) { console.error(e); }
})();
})();
